var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.abilities),function(ability){return _c('div',[_c('base-widget',{key:ability.Name,attrs:{"ability":ability,"useDivider":true,"showChart":true}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }